import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  name: 'Martín',
  age: 34,
  city: 'Rosario',
  text: 'Trabajo todo el día y llegaba a casa a comer cualquier cosa. Desde que leí esto, armo las milanesas el finde y en la semana como un rey sin pensar. ¡Un viaje de ida!'
}, {
  name: 'Laura',
  age: 41,
  city: 'Córdoba',
  text: 'Mis hijos siempre me pedían milanesas y yo las hacía secas y aburridas. Apliqué el truco del empanado doble y ahora me dicen que cocino mejor que la abuela jaja.'
}, {
  name: 'Diego',
  age: 28,
  city: 'Buenos Aires',
  text: 'Pensé que sabía hacer milanesas hasta que leí el Tomo 3 sobre la fritura. Me cambió la vida, ya no me quedan aceitosas. Vale cada peso.'
}, {
  name: 'Sofía',
  age: 36,
  city: 'Mendoza',
  text: 'Lo compré por las guarniciones y terminé enamorada de todo el sistema. Organizar el freezer como explican acá te salva la semana entera.'
}, {
  name: 'Javier',
  age: 45,
  city: 'Mar del Plata',
  text: 'Excelente guía. Fui directo a las versiones gourmet para una cena con amigos y quedaron todos locos con la milanesa a la suiza. 100% recomendado.'
}];
export function Testimonials() {
  return <section className="bg-bordo-dark text-crema py-20 px-4 md:px-8" data-id="element-121">
      <div className="max-w-6xl mx-auto" data-id="element-122">
        <h2 className="text-3xl md:text-5xl font-serif font-bold text-center mb-16 text-dorado" data-id="element-123">
          Lo que dicen los que ya no improvisan
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-124">
          {testimonials.map((t, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-crema text-bordo p-6 rounded-xl shadow-lg" data-id="element-125">
              <div className="flex gap-1 mb-4 text-dorado" data-id="element-126">
                {[...Array(5)].map((_, i) => <Star key={i} size={18} fill="currentColor" data-id="element-127" />)}
              </div>
              <p className="italic mb-6 text-gray-800" data-id="element-128">"{t.text}"</p>
              <div className="font-bold" data-id="element-129">
                {t.name}, {t.age} años
              </div>
              <div className="text-sm text-gray-600" data-id="element-130">{t.city}</div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}